
import { ConversationItem } from '@/dataTypes/types';
import { defineComponent, PropType } from 'vue';
import { format } from 'date-fns';

export default defineComponent({
  props: {
    conversation: {} as PropType<ConversationItem>,
  },
  computed: {
    isMessageUnread() {
      const lastMessage = this.conversation?.last_message;
      return (
        !lastMessage?.viewed_at && lastMessage?.participant_type !== 'Gallery'
      );
    },
  },
  methods: {
    formatDate() {
      const updatedAt = this.conversation?.last_message?.updated_at;
      if (updatedAt) {
        return format(new Date(updatedAt), 'yyyy-MM-dd hh:mm a');
      } else {
        return '';
      }
    },
  },
});
